<template>
  <div>
    <a-page-header>
      <template v-slot:title>
        <a-space align="center">
          <div
            class="ant-descriptions-title"
            style="font-size: 20px; margin-bottom: 0px"
          >
            房源管理
          </div>
        </a-space>
      </template>
      <!-- actions -->
      <template v-slot:extra>
        <!-- 固钉 -->
        <a-affix :offset-top="10">
          <a-button-group style="margin-right: 2px">
            <template v-if="toDetailData.isEditable">
              <a-button @click="back">返回</a-button>
              <a-button type="primary" @click="onSubmit">提交</a-button>
            </template>
            <!-- 审批通过/其他 -->
            <a-button v-else @click="back" type="primary">返回</a-button>
          </a-button-group>
        </a-affix>
      </template>

      <ResourceInfo
        :isEditable="toDetailData.isEditable"
        :webId="toDetailData.webId"
        :selectRightList="toDetailData.selectRightList"
        ref="resourceInfoRef"
        @back="back()"
      ></ResourceInfo>

      <!-- 回到最高点 -->
      <a-back-top style="margin-right: -100px" />
    </a-page-header>
  </div>
</template>

<script>
import ResourceInfo from "./resourceInfo/ResourceInfo";
import { scrollToTop } from "@/utils/util";
export default {
  props: {
    toDetailData: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    ResourceInfo,
  },

  data() {
    return {};
  },
  methods: {
    back() {
      this.$emit("changeToLeader");
      scrollToTop(this);
    },
    onSubmit() {
      // 提交（校验 + 提交）
      this.$refs.resourceInfoRef.handleSubmit();
    },
  },
};
</script>

<style lang="less" scoped>
</style>